module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pain3@3x.b36df269.png";